import React from "react";
import { Client } from "@stomp/stompjs";
import { AlertContext } from "src/contexts/context";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { extractTicketInfo } from "src/util/utilFunctions";
import { isNewTicketCreated } from "src/util/utilFunctions";
const socketUrl=process.env.REACT_APP_SOCKET_ENDPOINT;
const SOCKET_URL = `ws://${socketUrl}/ws-message`;
const isInIframe = window.self !== window.top;
const icons = [
  <CheckCircleIcon />,
  <ReportProblemIcon
    htmlColor="yellow"
    sx={{ fill: "rgb(255, 564, 253) !important" }}
  />,
  <ReportProblemIcon
    htmlColor="orange"
    sx={{ fill: "rgb(255, 564, 253) !important" }}
  />,
  <ReportProblemIcon
    htmlColor="red"
    sx={{ fill: "rgb(255, 564, 253) !important" }}
  />,
  <CancelIcon />,
];

class App_Stomp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: "You server message here.",
      events: 0,
    };
  }

  componentDidMount() {
    //method is called after the component is rendered.
    let currentComponent = this;
    let onConnected = (client) => {
      // console.log("Connected!!");
      switch (client) {
        case 1:
          break;
        case 2:
          client2.subscribe("/topic/action", function (msg) {
            if (msg.body) {
              var jsonBody = JSON.parse(msg.body);
              if (jsonBody.message) {
                // if (isNewTicketCreated(jsonBody.message)) {
                //   currentComponent.context.setTicketPageUpdate(true); // update page for other users if new ticket has been created
                // }
                const foundMatch = extractTicketInfo(jsonBody.message);
                if (foundMatch) {
                  currentComponent.context.setTicketUpdate({
                    fatherId: foundMatch[0],
                    status: foundMatch[1],
                  });
                }

                currentComponent.context.setSuccess((prev) => [
                  ...prev,
                  {
                    status: true,
                    message: <span> {jsonBody.message}</span>,
                    index: prev.length,
                  },
                ]);
              }
            }
          });
          break;
        case 3:
          client3.subscribe("/topic/alarm", function (msg) {
            //console.log("alarm subscription!!");
            // client.subscribe('/topic/message', function (msg) {
            if (msg.body) {
              currentComponent.context.setAlarmPageUpdate(true); //USED TO UPDATE ALARMS PAGE
              currentComponent.context.setTicketPageUpdate(true); // USED TO UPDATE TICKETS PAGE
              // console.log("new Event with body:" + msg.body);
              var jsonBody = JSON.parse(msg.body);
              if (jsonBody) {
                if (
                  localStorage["alarms"] !== undefined &&
                  currentComponent.context.alarms.data.length === 0
                ) {
                  let existingAlarmsString = localStorage.getItem("alarms");
                  var existingAlarms = JSON.parse(existingAlarmsString);

                  if (existingAlarms.length === 100) {
                    existingAlarms.shift();
                  }
                  var alarm = {
                    id: existingAlarms.slice(-1)[0].id + 1,

                    title: jsonBody.itemSN,
                    severity: jsonBody.impact,
                    value: jsonBody.value,
                    date: new Date().toLocaleString(),
                    details: jsonBody.message,
                  };
                  existingAlarms.push(alarm);
                  let alarmString = JSON.stringify(existingAlarms);
                  localStorage.setItem("alarms", alarmString);
                  var counter = alarm.id + 1;
                  currentComponent.context.setAlarms({
                    data: existingAlarms,
                    counter: counter,
                  });
                } else {
                  currentComponent.context.setAlarms((alarms) => {
                    var counter = alarms.counter;

                    var alarm = {
                      id: counter,

                      title: jsonBody.itemSN,
                      severity: jsonBody.impact,
                      value: jsonBody.value,
                      date: new Date().toLocaleString(),
                      details: jsonBody.message,
                    };

                    if (alarms.data.length === 100) {
                      alarms.data.shift();
                    }

                    counter = counter + 1;

                    let existingAlarmsString = localStorage.getItem("alarms");
                    var existingAlarms =
                      existingAlarmsString === null
                        ? []
                        : JSON.parse(existingAlarmsString);

                    if (existingAlarms.length === 100) {
                      existingAlarms.shift();
                    }
                    existingAlarms.push(alarm);
                    let alarmString = JSON.stringify(existingAlarms);
                    localStorage.setItem("alarms", alarmString);
                    return { data: [...alarms.data, alarm], counter: counter };
                  });
                }

                currentComponent.context.setAlarmError((prev) => [
                  ...prev,
                  {
                    status: true,
                    alarm: true,
                    refetch: true,
                    message: (
                      <span style={{ display: isInIframe ? "none" : "" }}>
                        Alarm triggered for item: {jsonBody.itemSN} <br />  Severity : {jsonBody.impact}<br /> 
                        Value reached :{" "}{jsonBody.value} 
                      </span>
                    ),
                    index: prev.length,
                  },
                ]);
              }
            }
          });
          break;
        case 5:
          client5.subscribe("/topic/ticket", function (msg) {
            if (msg.body) {
              var jsonBody = JSON.parse(msg.body);
              if (jsonBody) {
                const userRoles =
                  JSON.parse(localStorage.getItem("roles")) || [];
                const usernameFromStorage = localStorage.getItem("userName"); //put in here because sometimes outside they are null
                const canSeeTicket =
                  userRoles.includes("owner") ||
                  userRoles.includes("organization") ||
                  userRoles.includes("recipient");
                const mntOpCanSeeTicket =
                  userRoles.length === 1 &&
                  userRoles.includes("maintenance") &&
                  jsonBody.userName === usernameFromStorage;
                if (mntOpCanSeeTicket || canSeeTicket) {
                  currentComponent.context.setTicketPageUpdate(true);
                  currentComponent.context.setNewTicket(jsonBody);
                }
              }
            }
          });
          break;

        default:
          client4.subscribe("/topic/predict", function (msg) {
            if (msg.body) {
              currentComponent.context.setAlarmPageUpdate(true); // USED TO UPDATE ALARM PAGE
              currentComponent.context.setTicketPageUpdate(true); // USED TO UPDATE TICKETS PAGE
              //console.log("new Event with body:" + msg.body);
              var jsonBody = JSON.parse(msg.body);
              if (jsonBody) {
                currentComponent.context.setAiPredictions((prev) => [
                  ...prev,
                  {
                    status: true,
                    assetSerial: jsonBody.assetSn,
                    prediction: (() => {
                      const prediction = JSON.parse(jsonBody.aiPrediction);
                      return prediction.faultPrediction;
                    })(),

                    index: prev.length,
                  },
                ]);
                currentComponent.setState({
                  messages: (
                    <span style={{ display: isInIframe ? "none" : "" }}>
                      "new Event with body:" {msg.body}
                    </span>
                  ),
                });
              }
            }
          });
          break;
      }
    };

    let onDisconnected = () => {
      console.log("Disconnected!!");
    };

    const client2 = new Client({
      brokerURL: SOCKET_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => onConnected(2),
      onDisconnect: onDisconnected,
    });

    const client3 = new Client({
      brokerURL: SOCKET_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => onConnected(3),
      onDisconnect: onDisconnected,
    });

    const client4 = new Client({
      brokerURL: SOCKET_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => onConnected(4),
      onDisconnect: onDisconnected,
    });
    const client5 = new Client({
      brokerURL: SOCKET_URL,
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
      onConnect: () => onConnected(5),
      onDisconnect: onDisconnected,
    });
    // client1.activate();
    client2.activate();
    client3.activate();
    client4.activate();
    client5.activate();
  }

  render() {
    return <div style={{ display: "none" }}></div>;
  }
}

export default App_Stomp;

App_Stomp.contextType = AlertContext;
